import * as React from 'react';
import { Checkbox } from '../../../../Shared';

const SubjectAreaRow = ({ setSelectedSubjectAreaIds, subjectArea, selectedSubjectAreaIds, }) => {
  const isSelected = selectedSubjectAreaIds.includes(subjectArea.id)

  function handleClickCheckbox() {
    if (selectedSubjectAreaIds.includes(subjectArea.id)) {
      setSelectedSubjectAreaIds(selectedSubjectAreaIds.filter(id => id !== subjectArea.id))
    } else {
      setSelectedSubjectAreaIds(selectedSubjectAreaIds.concat(subjectArea.id))
    }
  }

  return (
    <div className="subject-area-row">
      <Checkbox
        label={subjectArea.name}
        onClick={handleClickCheckbox}
        selected={isSelected}
      />
    </div>
  )
}

const SubjectAreaSection = ({ subjectAreas, setSelectedSubjectAreaIds, selectedSubjectAreaIds, }) => {
  return subjectAreas.map(sa =>
    (
      <SubjectAreaRow
        key={sa.id}
        selectedSubjectAreaIds={selectedSubjectAreaIds}
        setSelectedSubjectAreaIds={setSelectedSubjectAreaIds}
        subjectArea={sa}
      />
    )
  )
}

export default SubjectAreaSection
